import { User } from '../user/types'
import { Classified } from '~/models/classified/types'
import { Pagination } from '~/models/search/types'

export interface ClassifiedList {
  name: string
  description: string
  classifiedsCount: number
  created: Date
  publicId: string
  shareUrl: string
  user: User
  isReadonly: boolean
  isFavorite: boolean
  isClassifiedInList: boolean
  commentingEnabled: boolean
  reactionsEnabled: boolean
  classifieds: { pagination: Pagination; rows: Classified[] }
}

export enum ReactionEnum {
  LOVE = 'love',
  SARCASTIC = 'sarcastic',
  MONEY = 'money',
  WINK = 'wink',
  LAUGHING = 'laughing',
  LIKE = 'like',
  DISLIKE = 'dislike'
}

export interface RecentReactions {
  reaction: ReactionEnum
  user: User
  created: Date
}

export interface Reactions {
  myReactions: Array<string>
  recentReactions: Array<RecentReactions>
  reactionsCounts: { [key: string]: number }
  totalReactionsCount: number
  reactionsPairs: []
}

export interface ClassifiedListComment {
  added: string
  comment: string
  isNonPublic: Boolean
  isDeleted: Boolean
  parentId: number
  user: User
  replies: Array<ClassifiedListComment>
  id: number
  repliesCount: number
  repliesHasMore: Boolean
  reactions: { [key: string]: number }
  reactionsPairs: Array<Array<[]>>
  totalReactionsCount: number
  myReactions: Array<string>
}

export interface ReactionsObject {
  reactions: { [key: string]: number }
  totalReactionsCount: number
  reactionsPairs: Array<Array<[]>>
}
